import React from 'react';
import ReactPlayer from 'react-player';

import { Box } from '@mui/material';

import { Modal } from '../Modal/Modal';

export const LeaderboardVideoModal = ({
  open,
  onCloseModal,
  videoLink,
}: {
  open: boolean;
  onCloseModal: VoidFunction;
  videoLink?: string;
}) => {
  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      withoutPadding
      content={
        <Box overflow="hidden" display="flex" justifyContent="center">
          <ReactPlayer url={videoLink} controls width="100%" />
        </Box>
      }
    />
  );
};
